// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/activity.js';

import { paths } from '../generated/activity';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('activity', Original, paths);
